var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-container',[_c('b-row',{staticClass:"container"},[_c('b-col',{staticClass:"error-page_message"},[_vm._v(" 404 Error Page Not Found "),_c('br'),_vm._v(" Please try later or another url :( ")])],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }